import { TwoFactorWithSsoModalComponent } from '~/_shared/components/accountSettings/twoFactorModal/twoFactorWithSsoModal.component';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    TwoFaWithSso: undefined;
  }
}

modalRenderer.register('TwoFaWithSso', TwoFactorWithSsoModalComponent);
